<div class="raw main">
    <div class="col-12 success">
        <div class="col-8">
            <h1>報名完成</h1>
            <div class="info">
                <span>恭喜您已成功完成報名，提醒您：</span>
                <ul>
                    <li>報名資料將由買主篩選並決定洽談會時段，本會將另行通知獲選廠商正式洽談時段。</li>
                    <li>請儘速至<a href="">台灣經貿網</a>更新貴公司之公司簡介及產品型錄，以增加獲選機會。</li>
                    <li>您所報名之採購案皆可至「我的預約」查詢進度。</li>
                </ul>
            </div>
            <div class="content">
                <div class="item">
                    <label>採購案名稱</label>
                    <p class="active">{{Data.currentEvent.name}}</p>
                </div>
                <div class="item">
                    <label>買主公司</label>
                    <p class="active">{{Data.buyer.company_name}}</p>
                </div>
                <div class="item">
                    <label>洽談時段</label>
                    <p>{{Data.session.sessionTime.desc}}</p>
                </div>
                <div class="item">
                    <label>廠商統一編號</label>
                    <p>{{Data.companyMember.company.ban}}</p>
                </div>
                <div class="item">
                    <label>廠商公司</label>
                    <p>{{Data.companyMember.company.name}}</p>
                </div>
                <div class="item">
                    <label>參加人</label>
                    <p>{{Data.companyMember.name}} {{Data.companyMember.englishName}}</p>
                </div>
                <div class="item">
                    <label>手機</label>
                    <p>{{Data.companyMember.mobile}}</p>
                </div>
                <div class="item">
                    <label>Email</label>
                    <p>{{Data.companyMember.email}}</p>
                </div>
                <div class="item">
                    <label>公司電話</label>
                    <p>{{Data.companyMember.tel}}</p>
                </div>
            </div>
    
            <div class="btn_group">
                <div class="btn">
                    <a routerLink="/activity/{{Data.currentEvent.id}}">繼續報名</a>
                </div>
                <div class="btn-outline">
                    <a routerLink="/member/reserve">前往我的預約</a>
                </div>
            </div>
            
        </div>
    </div>

</div>

